import axios from '@/framework/router/axios'

const tempColDealWith = ({
  columns,
  propJson,
  tempCol
}) => {
  const jsonObj = JSON.parse(propJson)
  tempCol = {
    ...jsonObj,
    ...tempCol
  }
  if (jsonObj && jsonObj.dicOption === '2') {
    const { dicUrl, dicMethod } = jsonObj
    axios({
      method: dicMethod,
      url: dicUrl
    }).then(res => {
      tempCol.dicData = res.data
      columns.push(tempCol)
    })
  } else {
    columns.push(tempCol)
  }
  return tempCol
}

export {
  tempColDealWith
}
